import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";

import { IHomePageSectionsArrangementQuery } from "../../models/arrange_sections_page_home/query";
import { IHomePageSectionsArrangementList } from "../../models/arrange_sections_page_home/response";
import { IHomePageSectionsArrangement } from "../../models/arrange_sections_page_home/request";
import {IArea} from "../../models/area/response";

class HomeSectionsArrangementService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllHomePageSectionsArrangementLists = (query: IHomePageSectionsArrangementQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<IHomePageSectionsArrangementList>>({
      path: `/arrange-sections-page-home`,
      method: "GET",
      query,
      ...params,
    });

  updateHomePageSectionsArrangementList = (id: number, data: IHomePageSectionsArrangement, params?: RequestParams) =>
    this.http.request<IHomePageSectionsArrangementList>({
      path: `/arrange-sections-page-home/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  createHomePageSectionsArrangement = (data: IHomePageSectionsArrangement, params?: RequestParams) =>
    this.http.request<IHomePageSectionsArrangementList>({
      path: `/arrange-sections-page-home-store/banner-section`,
      method: "POST",
      body: data,
      ...params,
    });

    deleteHomePageSectionsArrangement = (id: number, params?: RequestParams) =>
        this.http.request<IHomePageSectionsArrangementList>({
            path: `/arrange-sections-page-home-destroy/banner-section/${id}`,
            method: "DELETE",
            ...params,
        });
}

export default HomeSectionsArrangementService;
